module.exports = __webpack_public_path__ + "img/R4DM24_ecoaims_logo.cf351034.png";